function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#1C1B1F",
  d: "M6 11.833a.84.84 0 0 1-.615-.26.84.84 0 0 1-.26-.615V6.875H1.042a.84.84 0 0 1-.615-.26A.84.84 0 0 1 .167 6q0-.354.26-.615a.84.84 0 0 1 .615-.26h4.083V1.042q0-.354.26-.615A.84.84 0 0 1 6 .167q.354 0 .615.26.26.261.26.615v4.083h4.083q.354 0 .615.26.26.261.26.615a.84.84 0 0 1-.26.615.84.84 0 0 1-.615.26H6.875v4.083a.84.84 0 0 1-.26.615.84.84 0 0 1-.615.26"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-add.svg";
export { SvgComponent as ReactComponent };